// extracted by mini-css-extract-plugin
export default {"component_ig":"NavigationTitle__component_ig--ig-qPJ1z","title_ig":"NavigationTitle__title_ig--ig-vTAAd","all_ig":"NavigationTitle__all_ig--ig-gyeHX"};